import React from 'react';
import { ClipboardList, Wrench, Activity } from 'lucide-react';
import { TabBar } from '../../components/ui';

const TABS = [
  { id: 'daily', label: 'Daily log', to: '/dashboard/operations/daily', icon: ClipboardList },
  { id: 'equipment', label: 'Fixed Assets', to: '/dashboard/assets/fixed', icon: Wrench },
  { id: 'maintenance', label: 'Maintenance', to: '/dashboard/operations', icon: Activity },
];

/** Operations hub tab strip — Daily log / Equipment / Maintenance. */
export default function OperationsTabs({ active }) {
  return <TabBar tabs={TABS} active={active} ariaLabel="Operations sections" />;
}
